import { fetchConfig, getConfig } from "./api";

export { fetchConfig, getConfig };
export default fetchConfig;
